import { render, staticRenderFns } from "./SystemRequirements.vue?vue&type=template&id=418ff373&scoped=true"
import script from "./SystemRequirements.vue?vue&type=script&lang=js"
export * from "./SystemRequirements.vue?vue&type=script&lang=js"
import style0 from "./SystemRequirements.vue?vue&type=style&index=0&id=418ff373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418ff373",
  null
  
)

export default component.exports